import { Commit, Module } from "vuex";

import { WorkPlaces } from "@/entities/InstallerSchedule/model/types/types";

import type { State } from "@/core/store/globalStore";

interface InstallerTableModuleState {
	selectedWorkPlaces: WorkPlaces[];
}

const initialState: InstallerTableModuleState = {
	selectedWorkPlaces: [],
};

export const installerTableModule: Module<InstallerTableModuleState, State> = {
	state: () => initialState,

	mutations: {
		setSelectedWorkPlaces(state: InstallerTableModuleState, workPlaces: WorkPlaces[]) {
			state.selectedWorkPlaces = workPlaces;
		},
		addWorkPlace(state: InstallerTableModuleState, workPlace: WorkPlaces) {
			if (!state.selectedWorkPlaces.includes(workPlace)) {
				state.selectedWorkPlaces.push(workPlace);
			}
		},
		removeWorkPlace(state: InstallerTableModuleState, workPlace: WorkPlaces) {
			state.selectedWorkPlaces = state.selectedWorkPlaces.filter((wp) => wp !== workPlace);
		},
	},

	getters: {
		getSelectedWorkPlaces: (state: InstallerTableModuleState) => state.selectedWorkPlaces,
	},

	actions: {
		updateSelectedWorkPlaces: ({ commit }: { commit: Commit }, workPlaces: WorkPlaces[]) => {
			commit("setSelectedWorkPlaces", workPlaces);
		},
		toggleWorkPlaceSelection: (
			{ commit, state }: { commit: Commit; state: InstallerTableModuleState },
			workPlace: WorkPlaces,
		) => {
			if (state.selectedWorkPlaces.includes(workPlace)) {
				commit("removeWorkPlace", workPlace);
			} else {
				commit("addWorkPlace", workPlace);
			}
		},
	},

	namespaced: true,
};
